import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from '@teach/ui'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from '../messages'
import type { McpConnection } from '../types'
import { clientBrand } from '../lib/clientBrand'

interface Props {
  conn: McpConnection
  onRevoke: (clientId: string) => void
  revoking: boolean
}

export const ConnectionRow = ({ conn, onRevoke, revoking }: Props) => {
  const m = useMessages(messages)
  const name = conn.client_name ?? 'Claude'
  const { icon: Logo, tileClass } = clientBrand(conn.client_name)
  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-4">
      <div
        className={cn('flex h-10 w-10 shrink-0 items-center justify-center rounded-xl', tileClass)}
      >
        <Logo className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        {/* Даты подключения и последнего использования скрыты (решение заказчика,
            13.10.2026): сервер переписывает `connected_at` на каждом переподключении,
            а `last_used_at` не обновляет — строка вводила в заблуждение. Вернуть после
            ответа бэка (docs/backend-questions.md, п.38). */}
        <p className="truncate font-medium text-foreground">{name}</p>
      </div>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="ghost" size="sm" disabled={revoking}>
            {m.revoke}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{m.revokeTitle(name)}</AlertDialogTitle>
            <AlertDialogDescription>{m.revokeDescription}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{m.cancel}</AlertDialogCancel>
            <AlertDialogAction onClick={() => onRevoke(conn.client_id)}>
              {m.revokeConfirm}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
